import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Paper, Theme, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getPrefersDarkMode, getSearchInput } from '../../../store/settings/settings.selectors'
import {
  Event,
  EventLocation,
  EventLocationResponse,
  EventMember,
  EventMemberResponse,
  EventResponse,
  Member,
  MemberResponse,
  RelationResponse,
} from '../../../shared/types'
import {
  getEventLocations,
  getEventMember,
  getEvents,
  getMembers,
  getRelations,
} from '../../../store/data/data.selectors'
import { FamilyNode } from '../FamilyMember/FamilyTree/types'
import getDataBiography from '../Dashboard/getDataBiography'
import getDataGeography from '../Dashboard/getDataGeography'
import DOMPurify from 'dompurify'
import getDateStringFromCustomDate from '../../../util/getDateStringFromCustomDate'
import { makeStyles } from '@mui/styles'
import * as settingsActions from '../../../store/settings/settings.actions'

export enum MainSource {
  member = 'member',
  event = 'event',
  relation = 'relation',
  ottoMeissner = 'ottoMeissner',
  leipzig = 'leipzig',
  niederstaucha = 'niederstaucha',
}

export interface SearchResult {
  mainSource: MainSource
  element?: string | number
}

export interface SearchObject {
  member: Member[]
  event: Event[]
  relation: FamilyNode[]
  fullText: SearchResult[]
}

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    cursor: 'pointer',
    color: theme.palette.secondary.dark,
  },
}))

const SearchResults: React.FC = () => {
  const theme = useTheme()
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()

  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const darkMode = useSelector(getPrefersDarkMode)

  const searchResult: string | undefined = useSelector(getSearchInput)

  const members: MemberResponse | undefined = useSelector(getMembers)
  const events: EventResponse | undefined = useSelector(getEvents)
  const eventMembers: EventMemberResponse | undefined = useSelector(getEventMember)
  const locations: EventLocationResponse | undefined = useSelector(getEventLocations)
  const relations: RelationResponse | undefined = useSelector(getRelations)

  const [data, setData] = useState<SearchObject>()
  const [regEx, setRegEx] = useState<RegExp[]>([])

  const memberTermArray = [
    'city', 'zip', 'lastname', 'firstname', 'address', 'birthname', 'country', 'dietType', 'email', 'gender', 'middlenames', 'nickname', 'gender', 'phone', 'placeOfBirth', 'placeOfDeath', 'title']
  const eventTermArray = [
    'title', 'signature']

  useEffect(() => {
    const searchResultArray: string[] | undefined = searchResult?.split(' ')
    const regExArray: RegExp[] = []
      searchResultArray?.map(elem => {
        elem && regExArray.push(new RegExp(elem.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss'), 'gim'))
      })
      setRegEx(regExArray)
      type tempSearchResult = {
        [key: number]: SearchResult[]
      }
      const temp: tempSearchResult = {}
      if (regExArray.length > 0) {
        regExArray.map((regEx, index) => {
          temp[index] = []
          // member
          members?.results.map((member: Member) => {
            memberTermArray.map((term: string) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              if (member[term] && member[term]?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) {
                if (!temp[index].find(elem => elem.element === member.id && elem.mainSource === MainSource.member)) {
                  temp[index].push({
                    mainSource: MainSource.member,
                    element: member.id,
                  })
                }
              }
            })
          })
          // events
          events?.results.map((event: Event) => {
            eventTermArray.map((term: string) => {
              const location: EventLocation | undefined = locations?.results.find(loc => loc.id === event.locationId)
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              if ((event[term] && event[term]?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) ||
                (event.from?.year && event.from.year.toString().search(regEx) > -1) ||
                (location?.caption && location?.caption?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) ||
                (location?.name && location?.name?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) ||
                (location?.linkUrl && location?.linkUrl?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)
              ) {
                if (!temp[index].find(elem => elem.element === event.id && elem.mainSource === MainSource.event)) {
                  temp[index].push({
                    mainSource: MainSource.event,
                    element: event.id,
                  })
                }
              }
            })
          })
          // eventMember
          eventMembers?.results.map((eventMember: EventMember) => {
            const member: Member | undefined = members?.results.find(mem => mem.id === eventMember.memberId)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ((member?.firstname && member?.firstname?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) ||
              (member?.lastname && member?.lastname?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)
            ) {
              if (!temp[index].find(elem => elem.element === eventMember.eventId && elem.mainSource === MainSource.event)) {
                temp[index].push({
                  mainSource: MainSource.event,
                  element: eventMember.eventId,
                })
              }
            }
          })
          // relations
          relations?.results.map((relation: FamilyNode) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ((relation?.id && relation.id.search(regEx) > -1) ||
              (relation.parents.find(parent => parent.id.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)) ||
              (relation.siblings.find(sibling => sibling.id.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)) ||
              (relation.spouses.find(spouse => spouse.id.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)) ||
              (relation.children.find(child => child.id.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1))
            ) {
              if (!temp[index].find(elem => elem.element === relation.id && elem.mainSource === MainSource.relation)) {
                temp[index].push({
                  mainSource: MainSource.relation,
                  element: relation.id,
                })
              }
            }
          })
          const biographyOttoMeissner = getDataBiography('ottoMeissner')
          biographyOttoMeissner.map((cap, id) => {
            if ((cap.description && cap.description.search(regEx) > -1) || cap.title.search(regEx) > -1) {
              temp[index].push({
                mainSource: MainSource.ottoMeissner,
                element: id,
              })
            }
          })
          const geographyLeipzig = getDataGeography('leipzig')
          geographyLeipzig.map((cap, id) => {
            if ((cap && cap.search(regEx) > -1)) {
              temp[index].push({
                mainSource: MainSource.leipzig,
                element: id,
              })
            }
          })
          const geographyNiederstaucha = getDataGeography('niederstaucha')
          geographyNiederstaucha.map((cap, id) => {
            if ((cap && cap.search(regEx) > -1)) {
              temp[index].push({
                mainSource: MainSource.niederstaucha,
                element: id,
              })
            }
          })
        })
        // AND Verknüfung aller Suchergebnisse
        temp[0].map((element, index) => {
          for (let n = 1; n < Object.keys(temp).length; n += 1) {
            if (!temp[n].find(reference => JSON.stringify(reference) === JSON.stringify(element))) {
              delete temp[0][index]
            }
          }
        })
        const searchObject: SearchObject = {
          event: [],
          member: [],
          relation: [],
          fullText: [],
        }
        temp[0].map((acceptedResult) => {
          if (acceptedResult.mainSource === MainSource.member) {
            const el: Member | undefined = members?.results.find(elem => elem.id === acceptedResult.element)
            el && searchObject.member.push(el)
          }
          if (acceptedResult.mainSource === MainSource.event) {
            const el: Event | undefined = events?.results.find(elem => elem.id === acceptedResult.element)
            el && searchObject.event.push(el)
          }
          if (acceptedResult.mainSource === MainSource.relation) {
            const el: FamilyNode | undefined = relations?.results.find(elem => elem.id === acceptedResult.element)
            el && searchObject.relation.push(el)
          }
          if (acceptedResult.mainSource === MainSource.ottoMeissner) {
            searchObject.fullText.push(acceptedResult)
          }
          if (acceptedResult.mainSource === MainSource.leipzig) {
            searchObject.fullText.push(acceptedResult)
          }
          if (acceptedResult.mainSource === MainSource.niederstaucha) {
            searchObject.fullText.push(acceptedResult)
          }
        })
        setData(searchObject)
      }
  }, [searchResult],
  )

  const cleanText = (rawText: string) => {
    const cleanedText = rawText.replace('<br />', '')
    const index = cleanedText.search(regEx[0])
    const from = index < 100 ? 0 : index - 100
    const to = index + 100 > cleanedText.length ? cleanedText.length : index + 100
    const cap = cleanedText.slice(from, to)
    const newSearchtermArray = cap.split(' ')
    let newOutput = ''
    const highlightColor = darkMode ? theme.palette.primary.dark : theme.palette.primary.light
    newSearchtermArray.map(element => {
      if (element.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx[0]) > -1) {
        newOutput += `<span style="background-color: ${highlightColor}; color: #000000;">${element}</span> `
      } else {
        newOutput += `${element} `
      }
    })
    return `...${newOutput}...`
  }

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      {searchResult ? (
        <>
          <Typography variant='h1'>"{searchResult}"</Typography>
          {data?.fullText && data.fullText.length > 0 && <Typography variant='h2'>Suchergebnisse</Typography>}
          {data?.fullText.map((text) => {
            if (text.mainSource === MainSource.leipzig) {
              return (
                <Box
                  className={classes.link} onClick={() => {
                    dispatch(settingsActions.setNavPoint(['family', 'leipzig']))
                    history.replace('/family/leipzig')
                  }}
                >
                  <Typography
                    variant='body1'
                    dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(cleanText(getDataGeography('leipzig')[text.element as number] as string))}` }}
                  />
                </Box>
              )
            }
            if (text.mainSource === MainSource.niederstaucha) {
              return (
                <Box
                  className={classes.link} onClick={() => {
                    dispatch(settingsActions.setNavPoint(['family', 'niederstaucha']))
                    history.replace('/family/niederstaucha')
                  }}
                >
                  <Typography
                    variant='body1'
                    dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(cleanText(getDataGeography('niederstaucha')[text.element as number] as string))}` }}
                  />
                </Box>
              )
            }
            if (text.mainSource === MainSource.ottoMeissner) {
              return (
                <Box
                  className={classes.link} onClick={() => {
                    dispatch(settingsActions.setNavPoint(['family', 'ottoMeissner']))
                    history.replace('/family/ottoMeissner')
                  }}
                >
                  <Typography
                    variant='body1'
                    dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(cleanText(getDataBiography('ottoMeissner')[text.element as number].description as string))}` }}
                  />
                </Box>
              )
            }
          }
            )}

          {data?.member && data?.member.length > 0 && <Typography variant='h2'>Familienmitglieder</Typography>}
          {data?.member.map((mem) => (
            <Box
              key={mem.id}
              className={classes.link} onClick={() => {
                dispatch(settingsActions.setNavPoint(['familyMember']))
                history.replace('/familyMember/table')
              }}
            >
              <Typography
                variant='body1'
              >{`${mem.firstname} ${mem.middlenames ? mem.middlenames : ''} ${mem.lastname} ${getDateStringFromCustomDate(mem.birthday)}${mem.deathday.year ? ` - ${getDateStringFromCustomDate(mem.deathday)}` : ''}`}
              </Typography>
            </Box>
          ))}

          {data?.relation && data?.relation.length > 0 && <Typography variant='h2'>Nahe Verwandte</Typography>}
          {data?.relation.map((rel, index) => (
            <Typography
              key={index}
            >{`${members?.results.find(elem => elem.id === rel.id)?.firstname} ${members?.results.find(elem => elem.id === rel.id)?.lastname}`}
            </Typography>
          ))}

          {data?.event && data?.event.length > 0 && <Typography variant='h2'>Skatturniere</Typography>}
          {data?.event.map((ev) => (
            <Box
              key={ev.id}
              className={classes.link}
              onClick={() => {
                dispatch(settingsActions.setNavPoint(['events']))
                history.replace('/events')
              }}
            >
              <Typography>{events?.results.find(elem => elem.id === ev.id)?.title}</Typography>
            </Box>
          ))}
        </>
      )
        : (
          <>
            <Typography variant='h2'>Keine Suchergebnisse</Typography>
            <Typography variant='body1'>Bitte trage zunächst etwas in die Suchmaske oben links ein. Wir versuchen dann
              alle relevanten Ergebnisse anzuzeigen. Neben Texten kann man hier die Daten der Familienmitglieder, ihrer
              Angehörigen, sowie alle Skatturiere durchsuchen.
            </Typography>
          </>
        )}
    </Paper>
  )
}

export default SearchResults
